import { render, staticRenderFns } from "./vipRenew.vue?vue&type=template&id=39b1204a&scoped=true&"
import script from "./vipRenew.vue?vue&type=script&lang=js&"
export * from "./vipRenew.vue?vue&type=script&lang=js&"
import style0 from "./vipRenew.vue?vue&type=style&index=0&id=39b1204a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b1204a",
  null
  
)

export default component.exports